module.exports = __webpack_public_path__ + "static/media/qrcode.a2eeb3c1.png";